import * as Yup from 'yup';


export const createGroupParams = Yup.object().shape({
    name: Yup.string().required('Please, provide the groups name'),
    // location: Yup.string().required('Please, provide the groups location'),
});